import React from 'react';
import SocialUl from './SocialUl';
import {
  StyledUl,
  StyledFooterBottom,
  StyledMaintenanceFooter,
} from './styles';

const MaintenanceFooter = () => (
  <StyledMaintenanceFooter>
    <StyledFooterBottom>
      <div className="row row--large">
        <div className="grid grid-two-col--wide-left-col grid-gap-up3">
          <div>
            <StyledUl>
              <li>{`Copyright ${new Date().getFullYear()} SendGrid`}</li>
            </StyledUl>
          </div>
          <div>
            <SocialUl />
          </div>
        </div>
      </div>
    </StyledFooterBottom>
  </StyledMaintenanceFooter>
);

export default MaintenanceFooter;
